import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1E3A5F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://1e9smb8.atoms.world/assets/fma-logo.png"
                alt="FMA수학학원 로고"
                className="h-9 w-auto"
              />
              <span className="text-lg font-bold">FMA수학학원</span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              대치동 원장직강(EBS 등 20여년의 강의 경력)<br />
              수학학원, FMA수학학원입니다.<br />
              학생 개별 맞춤식/과외식 수업을 대치동<br />
              최고 수준의 교육 전문가가 함께합니다.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-[#F59E0B] mb-4">
              바로가기
            </h3>
            <ul className="space-y-2">
              {[
                { href: "/about", label: "학원소개" },
                { href: "/notice", label: "공지사항 및 시간표" },
                { href: "/materials", label: "학습자료실" },
                { href: "/videos", label: "동영상 자료실" },
                { href: "/location", label: "오시는 길" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-slate-300 hover:text-white text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-[#F59E0B] mb-4">
              연락처
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-sm text-slate-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-[#F59E0B]" />
                </div>
                010-2368-3385
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-300">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#F59E0B]" />
                </div>
                서울특별시 강남구 대치동 933-29<br />동림빌딩 302호
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-300">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-global-line text-[#F59E0B]" />
                </div>
                <a
                  href="https://blog.naver.com/fmasky"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  네이버 블로그 바로가기
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-[#F59E0B] mb-4">
              운영시간
            </h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-slate-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-[#F59E0B]" />
                </div>
                월·화·수: 14:00 ~ 22:00
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-close-circle-line text-[#F59E0B]" />
                </div>
                목·금: 휴원
              </li>
              <li className="flex items-center gap-2 text-sm text-slate-300">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-[#F59E0B]" />
                </div>
                토·일: 10:00 ~ 22:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 text-center">
          <p className="text-slate-400 text-sm">
            © 2026 대치동 원장직강 FMA수학학원. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
